// eslint-disable-next-line import/prefer-default-export
export const ONBOARDING_STEP = {
  UPDATING_CONTACT_INFO: 2,
  WAITING_VERIFY_CONTACT_INFO: 3,
  DEPOSITING_MONEY: 4,
  REQUESTING_ADS_ACCOUNT: 5,
  USING_OFFICIAL_ADS_ACCOUNT: 6,
}
